import AdminSolidsControlEquipDetails from './AdminSolidsControlEquipDetails';
import AdminSolidsControlEquips from './AdminSolidsControlEquips';


export {
    AdminSolidsControlEquipDetails,
    AdminSolidsControlEquips,
};

export default AdminSolidsControlEquips;


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/SolidsControlEquips/index.tsx